module.exports = __webpack_public_path__ + "4ec23bd57d011c60148981fea86695cd.jpg";